// src/api/conductorApi.js
import { api } from "./client";

export const conductorApi = {
  // accountId narrows the result server-side to just that account's
  // engagements (see ListEngagementsQuery's own docstring on the backend).
  listEngagements: (accountId) =>
    api.get("/conductor/engagements/", {
      params: accountId != null ? { account_id: accountId } : undefined,
    }),
  createEngagement: (payload) => api.post("/conductor/engagements/", payload),
  getContext: (engagementId) => api.get(`/conductor/engagements/${engagementId}/context`),

  addTeamMember: (engagementId, payload) =>
    api.post(`/conductor/engagements/${engagementId}/team-members`, payload),
  removeTeamMember: (engagementId, userId) =>
    api.delete(`/conductor/engagements/${engagementId}/team-members/${userId}`),

  // Replaces the user's whole project-scoped role set on this engagement in
  // one call (the backend also has single-role POST/DELETE .../project-roles
  // routes for granting or revoking just one role at a time — no frontend
  // page needs that granularity right now, so there's no wrapper for it
  // here).
  setProjectRoles: (engagementId, userId, roleNames) =>
    api.put(`/conductor/engagements/${engagementId}/team-members/${userId}/roles`, {
      role_names: roleNames,
    }),

  recordReference: (engagementId, payload) =>
    api.post(`/conductor/engagements/${engagementId}/references`, payload),
};
